import { SvgIcon } from "@mui/material";

const BluePencil = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M19.2666 10.0723L13.9287 4.73438L3.90579 14.7614C3.47876 15.1884 3.1667 15.7181 2.99424 16.297L1.5407 21.2407C1.43805 21.5856 1.53249 21.9593 1.79117 22.2139C2.04985 22.4685 2.4194 22.5629 2.7643 22.4643L7.7039 21.0108C8.28285 20.8383 8.81253 20.5263 9.23956 20.0993L19.2666 10.0723ZM5.16635 16.3053L6.09843 15.9316V17.2455C6.09843 17.6069 6.39406 17.9025 6.7554 17.9025H8.06933L7.69568 18.8346C7.53144 18.9619 7.34667 19.0563 7.14958 19.1179L3.93864 20.0623L4.88303 16.8555C4.94052 16.6543 5.03906 16.4695 5.16635 16.3094V16.3053ZM14.446 8.24095C14.7006 8.49553 14.7006 8.91435 14.446 9.16892L8.53332 15.0816C8.27874 15.3362 7.85993 15.3362 7.60535 15.0816C7.35077 14.8271 7.35077 14.4083 7.60535 14.1537L13.5181 8.24095C13.7727 7.98638 14.1915 7.98638 14.446 8.24095Z"
        fill="#2771EC"
      />
      <path
        d="M21.7298 3.89178C22.7564 4.9183 22.7564 6.58125 21.7298 7.60777L19.2662 10.0714L13.9283 4.73352L16.392 2.26989C17.4185 1.24337 19.0814 1.24337 20.1079 2.26989L21.7257 3.88767L21.7298 3.89178ZM14.4457 9.16807L8.53296 15.0808C8.27839 15.3354 7.85957 15.3354 7.60499 15.0808C7.35042 14.8262 7.35042 14.4074 7.60499 14.1528L13.5177 8.2401C13.7723 7.98552 14.1911 7.98552 14.4457 8.2401C14.7003 8.49467 14.7003 8.91349 14.4457 9.16807Z"
        fill="#011E3D"
      />
    </SvgIcon>
  );
};

export default BluePencil;
